//
// Module for the ContactInformation Index view
//
rs.module("framework/content/contactinformation/index",

    ["controls/data/grid"],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, ajaxUrl) {

            var addAddressButton = $.js(jsSelectors.addAddressButton);

            // Hook up click event on the radio buttons to reload the grid data via ajax
            $.js(jsSelectors.filter).js(jsSelectors.currentAddressIndicators).find("input").on('click', function () {

                $.js(jsSelectors.filter).js(jsSelectors.loadingSpinner).show();

                gridModule.update(
                    ajaxUrl,
                    {
                        showAllAddresses: this.value
                    },
                    lrsGridApi.agGridApi,
                    function done(gridUpdate) {
                        $.js(jsSelectors.filter).js(jsSelectors.loadingSpinner).hide();

                        // Update the Add button url to include the current selection
                        addAddressButton.attr('href', gridUpdate.context.addUrl);
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);